import React, { Component } from 'react';
import _ from 'lodash';
import { Dropdown, Form, Grid } from 'semantic-grab-ui';
import './MetricsBreakdownSection.scss';
import MetricsStatsTable from 'omega-rtc/views/trident-campaigns/metrics/MetricsStatsTable';
import { CommsMetrics } from 'omega-rtc/types/trident-campaigns';
import { sumFields } from 'omega-rtc/views/trident-campaigns/metrics/utils';
import { CHANNEL_KEYS, METRICS_FIELD_MAPPING } from 'omega-rtc/constants/ucd';
import { Button, Tooltip } from 'grab-ui';
import MetricsDownloadCsv from '../../../../img/ucd_project_metrics_download_csv.svg';
import scribe from '@grab-x/scribe-web-sdk';
import ScribeEventName, { ScribeExtras } from 'omega-rtc/constants/scribe';

const ALL_CHANNELS = 'All Channels';

interface MetricsBreakdownSectionProps {
  metrics: Map<string, any>;
  lastUpdatedDate: string;
  reports: Array<{ name: string; url: string }>;
  campaignID: string;
  notSentMetrics: any;
  onFetchNotSentMetrics: () => void;
  isLoadingNotSentMetrics: boolean;
  nodeType?: string;
  droppedByXCO?: number;
}

interface MetricsBreakdownSectionState {
  selectedChannel: string;
}

class MetricsBreakdownSection extends Component<MetricsBreakdownSectionProps, MetricsBreakdownSectionState> {
  channelDropdownList: Array<{ key: string; text: string; value: string }>;

  constructor(props: MetricsBreakdownSectionProps) {
    super(props);
    this.state = {
      selectedChannel: ALL_CHANNELS,
    };
    const { metrics } = this.props;
    this.channelDropdownList = this.getChannelDropdownList(metrics);
  }


  // Aggregate total stats from all channels. Output: {"triggered"100, "sent":250, "delivered": 100, ...}
  getStatsFromAllChannel = (data: any): CommsMetrics => {
    let allChannelsStat: CommsMetrics = {};
    _.map(_.get(data, 'metrics', []), (channelStat: CommsMetrics, channel) => {
      // For PCI, Only add 'click' and 'open' count from 'PCI - Inbox', The rest are already taken from PCI - Push
      if (channel === CHANNEL_KEYS.pciInbox) {
        allChannelsStat.click += channelStat.click;
        allChannelsStat.open += channelStat.open;
      } else {
        allChannelsStat = sumFields(allChannelsStat, channelStat, _.values(METRICS_FIELD_MAPPING.default));
      }
    });
    return allChannelsStat;
  }

  handleChannelChange = (event: any, channel: any) => {
    this.setState({
      selectedChannel: channel.value,
    });
  }

  // Output : [{ "key": "Email", "text": "Email", "value": "Email}, {...}]
  getChannelDropdownList = (metrics: Map<string, any>) => {
    let channels = [ALL_CHANNELS];
    for (const stats of metrics.values()) {
      channels = channels.concat(_.keys(
        _.get(stats, 'metrics', {}),
      ));
    }
    channels = _.uniq(channels);
    return channels.map(channel => ({
      key: channel,
      text: channel,
      value: channel,
    }));
  }

  // Output: { "Control Group (10%)" : {"triggered": 100, "sent": 250, ...},..}
  constructTableData = (selectedChannel: string, commsMetrics: Map<string, any>) => {
    const groupNameToStats: Record<string, CommsMetrics> = {};
    _.map(commsMetrics, data => {
      const groupName = _.get(data, 'name', '');
      const stats = selectedChannel === ALL_CHANNELS
        ? this.getStatsFromAllChannel(data)
        : _.get(data, `metrics.${selectedChannel}`, {});

      groupNameToStats[groupName] = stats;
    });
    return groupNameToStats;
  }

  downloadNotSentReport = (campaignId: string, reportUrl: string) => {
    scribe.sendEvent(ScribeEventName.CAMPAIGN_METRICS, {
      campaignId,
      ...ScribeExtras.DOWNLOAD_REPORT,
    });
    window.location.href = reportUrl;
  }

  render() {
    const { metrics, lastUpdatedDate, reports, campaignID, notSentMetrics, onFetchNotSentMetrics, isLoadingNotSentMetrics, nodeType, droppedByXCO } = this.props;
    const { selectedChannel } = this.state;
    const tableData = this.constructTableData(selectedChannel, metrics);
    return (
      <div>
        <Grid className={'metrics-breakdown-header'}>
          <Grid.Row>
            <Grid.Column width={3}>
              <Form.Select
                label="Channel"
                id="channel"
                name="channel"
                options={this.channelDropdownList}
                value={this.state.selectedChannel}
                onChange={this.handleChannelChange}
              />
            </Grid.Column>

            <Grid.Column width={13} style={{ textAlign: 'right', padding: '30px 30px 0 0' }}>

              {!_.isEmpty(reports) ?
                <React.Fragment><Dropdown icon="" placement={'botomLeft'} className={'download-dropdown'}>
                  <Dropdown.Menu>
                    {
                      _.map(reports, (report) => {
                        return (<Dropdown.Item
                          onClick={() => this.downloadNotSentReport(campaignID, report.url)}
                        > {report.name} report</Dropdown.Item>);
                      })
                    }
                  </Dropdown.Menu>
                </Dropdown>
                <Button className="downloadBtn" type="link">
                  {' '}
                  <img alt="icon" src={MetricsDownloadCsv} />
                </Button>
                </React.Fragment>
                :
                <Tooltip title="Reports are not available" placement="bottom">
                  <Button className="downloadBtn" type="link" disabled>{' '}
                    <img alt="icon" src={MetricsDownloadCsv} style={{ opacity: 0.5 }} />
                  </Button>
                </Tooltip>
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <MetricsStatsTable
          selectedChannel={selectedChannel}
          headerTitle={'Group'}
          metricsStat={tableData}
          lastUpdatedDate={lastUpdatedDate}
          notSentMetrics={notSentMetrics}
          onFetchNotSentMetrics={onFetchNotSentMetrics}
          isLoadingNotSentMetrics={isLoadingNotSentMetrics}
          nodeType={nodeType}
          droppedByXCO={droppedByXCO}
        />
      </div>);
  }
}

export default MetricsBreakdownSection;
